import { SearchActionButtonSection } from '../../search/actionSection';
import ToolTipTable from '../../search/search-table';
import TooltipCards from './tooltip-cards';

function actionSection(actions) {
  return [
    {
      icon: 'edit',
      label: 'Edit',
      action: actions.select,
      routes: ['tooltip/search']
    },
    {
      icon: 'hand point up outline',
      label: 'Select',
      action: actions.select,
      routes: ['schema-editor', 'uniquefield']
    }
  ];
}

export default [
  {
    id: 'card-layout',
    icon: 'block layout',
    label: 'Card',
    description: 'Convert layout to a cards. More detail; less per page',
    component: TooltipCards,
    model: {
      actionSection
    }
  },
  {
    id: 'table-layout',
    icon: 'list layout',
    label: 'Table',
    description: 'Convert layout to a table. Less detail; more per page',
    model: [
      {
        label: 'Title',
        property: 'label',
        type: 'string'
      },
      {
        label: 'Body',
        property: 'text',
        type: 'string'
      },
      {
        label: 'Actions',
        type: 'component',
        component: SearchActionButtonSection,
        model: actionSection
      }
    ],
    component: ToolTipTable
  }
];
